module.exports = __webpack_public_path__ + "img/5-Games.c3462c12.jpg";